<template>
  <div class="card">
    <!--begin::Card body-->
    <div class="card-body p-0">
      <!--begin::Heading-->
      <div class="card-px text-left py-0 my-10">
        <h2 class="fs-1x fw-bolder mb-10">Perfil de Usuario</h2>
        <div class="row">
          <div class="col-md-12">
            <img
              :src="state.formData.imagen_segip"
              class="img-fluid img-thumbnail rounded mx-auto d-block"
              width="150"
              height="150"
              alt="SegipImage"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 mt-3">
            <label class="form-label">Número de Documento:</label>
            <input
              class="form-control fuente"
              disabled
              v-model="state.formData.nro_documento"
            />
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label">Complemento:</label>
            <input
              class="form-control fuente"
              disabled
              :value="state.formData.complemento"
            />
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label">Fecha de Nacimiento:</label>
            <input
              class="form-control fuente"
              disabled
              v-model="state.formData.fecha_nacimiento"
            />
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label">Nombres:</label>
            <input
              class="form-control fuente"
              disabled
              v-model="state.formData.nombres"
            />
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label">Apellido Paterno:</label>
            <input
              class="form-control fuente"
              disabled
              v-model="state.formData.primer_apellido"
            />
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label">Apellido Materno:</label>
            <input
              class="form-control fuente"
              disabled
              v-model="state.formData.segundo_apellido"
            />
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label">Género:</label>
            <input
              class="form-control fuente"
              disabled
              v-model="state.formData.genero"
            />
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label">Departamento:</label>
            <input
              class="form-control fuente"
              disabled
              v-model="state.formData.departamento"
            />
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label">Provincia:</label>
            <input
              class="form-control fuente"
              disabled
              v-model="state.formData.provincia"
            />
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label">Localidad:</label>
            <input
              class="form-control fuente"
              disabled
              v-model="state.formData.localidad"
            />
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label">Dirección:</label>
            <input
              class="form-control fuente"
              disabled
              v-model="state.formData.direccion"
            />
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label">Institución:</label>
            <input
              class="form-control fuente"
              disabled
              v-model="state.formData.institucion_pertenece"
            />
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label">Cargo:</label>
            <input
              class="form-control fuente"
              disabled
              v-model="state.formData.cargo"
            />
          </div>
          <div
            v-if="!state.formData.departamento_supervisar"
            class="col-md-4 mt-3"
          >
            <label class="form-label">Recinto Penitenciario:</label>
            <input
              class="form-control fuente"
              disabled
              v-model="state.formData.recinto_penitenciario"
            />
          </div>
          <div v-else class="col-md-4 mt-3">
            <label class="form-label">Departamento Supervisión:</label>
            <input
              class="form-control fuente"
              disabled
              v-model="state.formData.departamento_supervisar"
            />
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label">Nombre de Usuario:</label>
            <input
              class="form-control fuente"
              disabled
              v-model="state.formData.nombre_usuario"
            />
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label">Rol:</label>
            <input
              class="form-control fuente"
              disabled
              v-model="state.formData.nombre_rol"
            />
          </div>
        </div>
        <br />
        <h3>Usted puede actualizar los siguientes datos:</h3>
        <div class="row">
          <div class="col-md-6 mt-3">
            <label class="form-label required">Correo Institucional:</label>
            <input
              type="email"
              class="form-control fuente"
              ref="correo_electronico"
              id="correo_electronico"
              v-model="state.formData.correo_electronico"
            />
            <div
              class="input-errors"
              v-for="error of v$.formData.correo_electronico.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >Correo Institucional requerido</span
              >
              <span class="text-danger" v-else-if="error.$validator == 'email'"
                >Correo Institucional invalido</span
              >
              <span
                class="text-danger"
                v-else-if="error.$validator == 'maxLength'"
                >Rango de caracteres maximo: 40</span
              >
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <label class="form-label required">Número de Celular:</label>
            <input
              type="number"
              class="form-control fuente"
              ref="telefono_movil"
              id="telefono_movil"
              v-model="state.formData.telefono_movil"
            />
            <div
              class="input-errors"
              v-for="error of v$.formData.telefono_movil.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >Número Celular requerido</span
              >
              <span
                class="text-danger"
                v-else-if="error.$validator == 'minLength'"
                >Cantidad de dígitos mínima 8</span
              >
              <span
                class="text-danger"
                v-else-if="error.$validator == 'maxLength'"
                >Cantidad de dígitos máxima 8</span
              >
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 text-center">
            <button
              type="button"
              class="btn btn-danger px-4 mx-3"
              @click="back"
            >
              Cancelar
            </button>

            <button
              type="button"
              class="btn btn-success px-4 mx-3"
              @click="submitButton"
            >
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import useVuelidate from "@vuelidate/core";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import {
  required,
  email,
  minLength,
  maxLength,
  minValue,
} from "@vuelidate/validators";
import user from "@/user/composables/useUser";
import formatDate from "@/helpers/formatDate";
import personImg from "@/assets/person.png";
export default defineComponent({
  name: "myProfile",
  components: {},
  setup() {
    const router = useRouter();
    const correo_electronico = ref(null);
    const telefono_movil = ref(null);

    let id_usuario = JSON.parse(localStorage.getItem("user")).usuario;
    id_usuario = id_usuario.split(/[(,]+/);
    id_usuario = id_usuario[1];
    const state = reactive({
      formData: {
        perfil: true,
        departamento_supervisar: "",
        nombre_rol: "",
        id_persona: "",
        id_usuario: "",
        nro_documento: "",
        complemento: "",
        genero: "",
        fecha_nacimiento: "",
        nombres: "",
        primer_apellido: "",
        segundo_apellido: "",
        pais: "",
        departamento: "",
        provincia: "",
        localidad: "",
        direccion: "",
        telefono_movil: "",
        imagen_segip: "",

        institucion_pertenece: "",
        cargo: "",
        recinto_penitenciario: "",
        nombre_usuario: "",
        contrasena: "",
        correo_electronico: "",
        roles: [],
      },
    });

    const { infoUser, namePenitentiary, updateUser } = user();
    const format = (date) => {
      const formattedDate = formatDate(date);
      return formattedDate;
    };
    // SELECT RECINTOS PENITENCIARIOS
    const setUserInformation = async () => {
      const { data } = await infoUser(id_usuario);
      state.formData.departamento_supervisar = data.departamento_supervisar;
      state.formData.nombre_rol = data.nombre_rol;
      state.formData.id_persona = data.id_persona;
      state.formData.id_usuario = data.id_usuario;
      state.formData.nro_documento = data.nro_documento;
      state.formData.complemento = data.complemento;
      state.formData.genero = data.genero;
      state.formData.fecha_nacimiento = format(data.fecha_nacimiento);
      state.formData.nombres = data.nombres;
      state.formData.primer_apellido = data.primer_apellido;
      state.formData.segundo_apellido = data.segundo_apellido;
      state.formData.pais = data.pais;
      state.formData.departamento = data.departamento;
      state.formData.provincia = data.provincia;
      state.formData.localidad = data.localidad;
      state.formData.direccion = data.direccion;
      state.formData.telefono_movil = data.telefono_movil;
      if (data.imagen_segip) {
        state.formData.imagen_segip = data.imagen_segip;
      } else {
        // state.formData.imagen_segip = "../../../public/media/blank.png"
        state.formData.imagen_segip =
         personImg;
      }
      state.formData.institucion_pertenece = data.institucion_pertenece;
      state.formData.cargo = data.cargo;
      let recinto_penitenciario;
      if (data.id_recinto_penitenciario) {
        recinto_penitenciario = await namePenitentiary(
          data.id_recinto_penitenciario
        );
        recinto_penitenciario =
          recinto_penitenciario.data.nombre_recinto_penitenciario;
      } else {
        recinto_penitenciario = "";
      }
      state.formData.recinto_penitenciario = recinto_penitenciario;
      state.formData.nombre_usuario = data.nombre_usuario;
      state.formData.correo_electronico = data.correo_electronico;
    };

    onMounted(() => {
      setUserInformation();
      setCurrentPageBreadcrumbs(
        "Datos perfil de usuario",
        // eslint-disable-next-line prettier/prettier
        ["Información"]
      );
    });

    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
      timerProgressBar: true,
    });

    const rules = computed(() => {
      return {
        formData: {
          correo_electronico: { required, email, maxLength: maxLength(40) },
          telefono_movil: {
            required,
            maxLength: maxLength(8),
            minLength: minLength(8),
          },
        },
      };
    });
    const v$ = useVuelidate(rules, state);

    // BOTON CANCELAR
    const back = () => {
      router.push({ name: "dashboard" });
    };

    // BOTON REGISTRAR
    const submitButton = async () => {
      // console.log(state.formData)
      v$.value.$validate();
      if (!v$.value.$error) {
        // PARSEO DE VARIABLES DEL FORMULARIO
        state.formData.correo_electronico =
          state.formData.correo_electronico.replace(/['`"]+/g, "");
        // REDIRECCIONAMIENTO
        let data = await updateUser(state.formData);
        // ALERTAS
        if (data.data) {
          Toast.fire({
            icon: "success",
            title: data.data.message,
          });
        } else {
          Toast.fire({
            icon: "error",
            title: data.message.response.data,
          });
        }
      } else {
        // DEVUELVE LOS CAMPOS QUE FALTAN
        const expr = v$.value.$errors[0].$property;
        switch (expr) {
          case "telefono_movil":
            telefono_movil.value.focus();
            break;
          case "correo_electronico":
            correo_electronico.value.focus();
            break;
        }
      }
    };

    return {
      state,
      v$,

      submitButton,
      back,

      correo_electronico,
      telefono_movil,
    };
  },
});
</script>

<style>
.fuente {
  font-size: 0.97em;
  padding: 0.35em;
  font-weight: normal;
}
</style>
